import { EmeraldErrorModal } from 'src/common/api/emerald-error';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { UnitOfMeasureTypes } from 'src/common/enumerations/unit-of-measure-type';
import { ItemNotFound, ResourceNotFound } from 'src/common/helpers/error-code';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { cancelItemByCode } from 'src/home-page/business-logic/cancel-line-or-item';
import { getTotalQuantity } from 'src/item-list/components/tbr-list-helper';
import { addTransactionLine } from 'src/items-list/business-logic/add-transaction-line';
import {
  getSalesKeypadState,
  resetSalesKeypadState,
} from 'src/sales-keypad/business-logic/sales-keypad-operations';
import { handleTbrQuantitySelect } from 'src/transaction-search/business-logic/tbr-logic/handle-tbr-item-quantity';
import { IElectronicJournalRecord } from '../../common/interfaces/states/IElectronicJournalRecord';

export const tbrItemClick = async (
  item: IElectronicJournalRecord,
  tbrItemsList: IElectronicJournalRecord[],
): Promise<void> => {
  const givenMax = getTotalQuantity(item.tbrScanData ?? item.ItemId, tbrItemsList);
  if (!item.Selected && item.tbrReturnQty === 0) {
    if (givenMax > 1 && item.UnitOfMeasureCode === UnitOfMeasureTypes.Each) {
      return handleTbrQuantitySelect(givenMax, item.ItemId, item.tbrScanData);
    } else {
      const { metricValue, quantityEntered, isManualWeight } = getSalesKeypadState();
      const inputData: IItemInputData = {
        itemId: item.tbrScanData ?? item.ItemId,
        quantity: metricValue,
        quantityEntryMethod: quantityEntered ? EntryMethod.Keyed : EntryMethod.Automatic,
        isManualWeight: isManualWeight,
        entryMethod: item.tbrScanData ? EntryMethod.Scanned : EntryMethod.Automatic,
        manualQuantity: item.Quantity,
      };
      return addTransactionLine(inputData).finally(resetSalesKeypadState);
    }
  } else {
    const data: IItemInputData = {
      itemId: item.ItemId,
      quantity: item.tbrReturnQty,
    };
    return cancelItemByCode(data).catch(err => {
      if (
        err.code === ResourceNotFound ||
        err.code === ItemNotFound ||
        err.code === 'ItemNotFoundInTransaction_Message'
      ) {
        err = new EmeraldErrorModal({
          type: EmeraldDialogTypes.Error,
          message: 'Temporary_Error_TBR_void',
          subMessage: 'Temporary_Error_TBR_void_submessage',
          disableBackdropClick: true,
          closeButtonLabel: 'Cancel',
          hideCancelButton: true,
        });
      }
      throw err;
    });
  }
};
